var map = {
	"./Battle.jpg": "265d",
	"./Battle2.jpg": "4c04",
	"./Battle3.jpg": "6d37",
	"./Battle4.jpg": "fe7f",
	"./Battle5.jpg": "c670",
	"./Battle6.jpg": "9c22",
	"./enemies/armor-cloak.svg": "ba6b",
	"./enemies/axe-crossed.svg": "e69c",
	"./enemies/bow-long-arrow.svg": "01be",
	"./enemies/crossbow.svg": "1b3c",
	"./enemies/kalashnikov.svg": "ff5e",
	"./enemies/kunai.svg": "26a3",
	"./enemies/medic.svg": "14ad",
	"./enemies/rapier.svg": "c9ca",
	"./enemies/ring.svg": "e7f6",
	"./enemies/sabers-crossed.svg": "4813",
	"./enemies/scroll.svg": "f80b",
	"./enemies/skull.svg": "f457",
	"./enemies/sniper.svg": "e1ae",
	"./enemies/spear.svg": "2bf6",
	"./enemies/spell-book-open.svg": "121a",
	"./enemies/spell-book.svg": "9128",
	"./enemies/staff.svg": "75bb",
	"./enemies/sword-shield.svg": "f3a7",
	"./enemies/sword.svg": "a5a9",
	"./enemies/swords-crossed.svg": "4f00",
	"./enemies/unarmed.svg": "1378",
	"./enemies/wand.svg": "2a10",
	"./icons/times-square.svg": "cf30",
	"./lineart/anvil-hammer.svg": "d52c",
	"./lineart/armor-bracers.svg": "e3e9",
	"./lineart/armor-cloak.svg": "d9c6",
	"./lineart/armor-gloves.svg": "31e2",
	"./lineart/armor-helmet-spartan.svg": "d792",
	"./lineart/armor-shield-kite.svg": "618f",
	"./lineart/armor-vest.svg": "db94",
	"./lineart/axe-crossed.svg": "be20",
	"./lineart/bag-magic-powder.svg": "d7fa",
	"./lineart/bow-long-arrow.svg": "68b1",
	"./lineart/crossbow.svg": "ccbf",
	"./lineart/dd-dice-numbers.svg": "185e",
	"./lineart/frail.svg": "065b",
	"./lineart/inventory-bag.svg": "a051",
	"./lineart/kalashnikov.svg": "4be0",
	"./lineart/katana.svg": "0292",
	"./lineart/kunai.svg": "7ff1",
	"./lineart/mace.svg": "6dfb",
	"./lineart/magic-scroll.svg": "4d1f",
	"./lineart/medic.svg": "fbde",
	"./lineart/potion-extra-large.svg": "2ac6",
	"./lineart/potion-large.svg": "9e26",
	"./lineart/potion-love.svg": "1cf4",
	"./lineart/potion-medium.svg": "fd6d",
	"./lineart/potion-small.svg": "c34a",
	"./lineart/rapier.svg": "4a66",
	"./lineart/ring.svg": "4aeb",
	"./lineart/sabers-crossed.svg": "01d5",
	"./lineart/scroll.svg": "1425",
	"./lineart/shoes-boots.svg": "b4b9",
	"./lineart/skull.svg": "f197",
	"./lineart/sniper.svg": "9c98",
	"./lineart/spear.svg": "68fb",
	"./lineart/spell-book-open.svg": "9214",
	"./lineart/spell-book.svg": "7d15",
	"./lineart/staff.svg": "ab06",
	"./lineart/sword-flame.svg": "a105",
	"./lineart/sword-shield.svg": "a5c1",
	"./lineart/sword.svg": "ce7a",
	"./lineart/swords-crossed.svg": "482b",
	"./lineart/unarmed.svg": "f62f",
	"./lineart/wand.svg": "0d1d",
	"./portraits/Dante.jpg": "7f91",
	"./portraits/Idanto.jpg": "563e",
	"./portraits/Jondras.jpg": "c341",
	"./portraits/Laetitia.jpg": "831b",
	"./portraits/Nahima.jpg": "3f98",
	"./portraits/Richard.jpg": "2eb8",
	"./portraits/standardFighter.png": "d7b5",
	"./style.css": "6672"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ec9";